import { OrigemFaltaCadastrada } from '@acme/core'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { Info, Sparkles } from 'lucide-react'
import { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import {
    FaltaCadastrada,
    faltasCadastradas,
} from 'service/api/endpoints/faltas-cadastradas'
import { toast } from 'sonner'
import FormEditarFaltaCadastrada from '../forms/EditarFaltaCadastrada'
import { useDigitacaoContext } from '../pages/DigitacaoLayout'
import { useUpdateDigitacaoQueryData } from '../pages/useDigitacaoData'
import ExcluirFaltaCadastrada from './ExcluirFaltaCadastrada'

export default function DetalhesFaltaCadastradaDigitacao() {
    const { mutateAsync } = faltasCadastradas.mutations.useUpdate()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { id } = useParams()
    const [open, setOpen] = useState(false)
    const { data } = useDigitacaoContext()

    const falta = data.find(
        ({ faltaCadastrada }) => faltaCadastrada?.id === Number(id),
    )?.faltaCadastrada

    if (!falta) return null

    const handleSubmit: SubmitHandler<FaltaCadastrada> = data =>
        mutateAsync(
            {
                ...data,
                data: dayjs(data.data).toDate(),
            },
            {
                onSuccess: res => {
                    setQueryData('FALTA_CADASTRADA', res)
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            disableFields={
                !hasPermission(['update', 'FaltasJustificadasOuInjustificadas'])
            }
            defaultValues={{
                ...falta,
                isInjustificada: !falta.justificativa,
                isReadOnly: true,
            }}
            height="auto"
            width="45rem"
            onSubmit={
                hasPermission(['update', 'FaltasJustificadasOuInjustificadas'])
                    ? handleSubmit
                    : undefined
            }
        >
            <Dialog.Title>
                <div className="flex items-center gap-2 justify-between">
                    <span>
                        Detalhes da falta{' '}
                        {falta.justificativa ? 'justificada' : 'injustificada'}
                    </span>
                    {falta.origem === OrigemFaltaCadastrada.AUTOMATICA && (
                        <span
                            className="inline-flex items-center gap-1 rounded-full bg-muted text-muted-foreground px-2 py-1 text-xs font-medium"
                            title="Criada automaticamente pelo sistema durante o cálculo"
                        >
                            <Sparkles className="h-3 w-3" />
                            Automática
                        </span>
                    )}
                    {falta.origem === OrigemFaltaCadastrada.MANUAL && (
                        <span
                            className="inline-flex items-center gap-1 rounded-full bg-primary text-primary-foreground px-2 py-1 text-xs font-medium"
                            title="Criada ou editada manualmente - não será alterada pelo cálculo automático"
                        >
                            <Info className="h-3 w-3" />
                            Manual
                        </span>
                    )}
                </div>
            </Dialog.Title>
            <Dialog.Content dividers>
                <FormEditarFaltaCadastrada />
                <ExcluirFaltaCadastrada
                    open={open}
                    onClose={() => setOpen(false)}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                {hasPermission(
                    ['delete', 'FaltasJustificadasOuInjustificadas'],
                    () => (
                        <Dialog.Actions.PrimaryButton
                            color="error"
                            onClick={() => setOpen(true)}
                        >
                            Excluir
                        </Dialog.Actions.PrimaryButton>
                    ),
                )}
                {hasPermission(
                    ['update', 'FaltasJustificadasOuInjustificadas'],
                    () => (
                        <Dialog.Actions.PrimaryButton closeOnSubmit />
                    ),
                )}
            </Dialog.Actions>
        </Dialog.Root>
    )
}
